__turbopack_context__.v({
  "mobileGalleryFooter": "TemplateGalleryMobile-module-scss-module__UUGcPW__mobileGalleryFooter",
  "mobileGalleryHeader": "TemplateGalleryMobile-module-scss-module__UUGcPW__mobileGalleryHeader",
  "mobilePriceTaxNotice": "TemplateGalleryMobile-module-scss-module__UUGcPW__mobilePriceTaxNotice",
});
